import React from 'react'
import SVGComponent from './SVGComponent'


const OurLearningPath = () => {
    return (
        <div className="ourLearnP">

            <div className='headings'>
                <h2>Our Learning Path</h2>
                <h2>
                    Absolute Beginner
                    ➔
                    Algorithmic Programmer
                </h2>
            </div>

            <div className='SVGcards'>
           
               <SVGComponent />
                </div>
          
        </div>
    )
}

export default OurLearningPath